var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroCardIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FAC0D5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 24.8332H45.8334V43.1665C45.8334 43.6085 45.6578 44.0325 45.3453 44.345C45.0327 44.6576 44.6088 44.8332 44.1667 44.8332H15.8334C15.3914 44.8332 14.9675 44.6576 14.6549 44.345C14.3423 44.0325 14.1667 43.6085 14.1667 43.1665V24.8332ZM14.1667 17.3332C14.1667 16.8911 14.3423 16.4672 14.6549 16.1547C14.9675 15.8421 15.3914 15.6665 15.8334 15.6665H44.1667C44.6088 15.6665 45.0327 15.8421 45.3453 16.1547C45.6578 16.4672 45.8334 16.8911 45.8334 17.3332V24.8332H14.1667V17.3332Z",
    stroke: "#FF70A4",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3335 34.833L28.3335 39.833L38.3335 29.833",
    stroke: "#FF70A4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3335 13.1665V19.8332M36.6668 13.1665V19.8332",
    stroke: "#FF70A4",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroCardIcon2);
export default __webpack_public_path__ + "static/media/HeroCardIcon2.e7debb36779e7950b7159dd43bc04661.svg";
export { ForwardRef as ReactComponent };